import React from 'react';
import { useNavigate } from 'react-router-dom';
import { ShoppingBag, Ticket, Utensils, Wine, Sparkles, ChevronRight, Facebook, Instagram } from 'lucide-react';
import Header from '../components/Header';
import { trackEvent } from '../lib/analytics';
import './QuickAccess.css';

const ORDER_URL = 'https://royalbargrill.com';
const EVENTBRITE_URL = 'https://www.eventbrite.com/o/royal-bar-grill-120928056108';
const FACEBOOK_URL = 'https://www.facebook.com/share/1DoM8JfLno/?mibextid=wwXIfr';
const INSTAGRAM_URL = 'https://www.instagram.com/royalbaralbany?igsh=MWZxaGo0bnNiN21idQ%3D%3D&utm_source=qr';

const QuickAccess = () => {
  const navigate = useNavigate();

  const goHome = (sectionId, query = '') => {
    navigate(`/${query}`);
    setTimeout(() => {
      const el = document.getElementById(sectionId);
      if (el) el.scrollIntoView({ behavior: 'smooth' });
    }, 250);
  };

  const options = [
    {
      key: 'facebook',
      title: 'Follow Us on Facebook',
      desc: 'Stay updated with news and specials',
      Icon: Facebook,
      onClick: () => {
        trackEvent('facebook_click', { link_location: 'quick_access' });
        window.open(FACEBOOK_URL, '_blank', 'noopener,noreferrer');
      },
    },
    {
      key: 'instagram',
      title: 'Follow Us on Instagram',
      desc: 'See our latest photos @royalbaralbany',
      Icon: Instagram,
      onClick: () => {
        trackEvent('instagram_click', { link_location: 'quick_access' });
        window.open(INSTAGRAM_URL, '_blank', 'noopener,noreferrer');
      },
    },
    {
      key: 'events',
      title: 'Events & Reservations',
      desc: 'Reserve a seat and see upcoming events',
      Icon: Ticket,
      onClick: () => {
        trackEvent('eventbrite_click', { link_location: 'quick_access' });
        window.open(EVENTBRITE_URL, '_blank', 'noopener,noreferrer');
      },
    },
    {
      key: 'order',
      title: 'Order Online',
      desc: 'Order your favorites for pickup or delivery',
      Icon: ShoppingBag,
      onClick: () => {
        trackEvent('order_now_click', { link_location: 'quick_access' });
        window.open(ORDER_URL, '_blank', 'noopener,noreferrer');
      },
    },
    {
      key: 'food',
      title: 'Food Menu',
      desc: 'American classics & authentic Indian fusion',
      Icon: Utensils,
      onClick: () => goHome('menu', '?menu=american'),
    },
    {
      key: 'drinks',
      title: 'Drink Menu',
      desc: 'Cocktails, premium tequila, beer & wine',
      Icon: Wine,
      onClick: () => goHome('menu', '?menu=drinks'),
    },
    {
      key: 'specials',
      title: 'Daily Specials',
      desc: 'Weekly events and daily specials at Royal',
      Icon: Sparkles,
      onClick: () => goHome('events'),
    },
  ];

  return (
    <>
      <Header />
      <section className="quick-access-section" id="quick-access">
        <div className="quick-access-inner">
          <div className="quick-access-header">
            <h1 className="quick-access-title">Quick Access</h1>
            <p className="quick-access-subtitle">Jump straight to what you need</p>
          </div>
          <div className="quick-access-grid">
            {options.map(({ key, title, desc, Icon, onClick }) => (
              <button
                key={key}
                className="quick-access-card"
                onClick={onClick}
                data-testid={`quick-access-${key}`}
              >
                <span className="quick-access-icon"><Icon size={28} /></span>
                <span className="quick-access-text">
                  <span className="quick-access-card-title">{title}</span>
                  <span className="quick-access-card-desc">{desc}</span>
                </span>
                <ChevronRight size={22} className="quick-access-arrow" />
              </button>
            ))}
          </div>
        </div>
      </section>
    </>
  );
};

export default QuickAccess;
